import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  useLocation,
  useParams,
} from "react-router-dom";
import authRoutes from "./AuthRouter/authRoute";
import { useEffect } from "react";
import Error404 from "../Views/Error404/error404";
import TagManager from "react-gtm-module";
import { routes } from "./redirectsRoutes";
import { useTranslation } from "react-i18next";

const tagManagerArgs = {
  gtmId: "GTM-TP332RDS",
};

function getCurrentLocale() {
  const url = window.location.href;
  const splitUrl = url.split("/");
  return splitUrl[3];
}

function LanguageRedirectWrapper() {
  const location = useLocation();
  const { i18n } = useTranslation();
  const { lang } = useParams<{ lang: string }>();

  useEffect(() => {
    const detectedLang = getCurrentLocale();
    
    // If no language in URL or invalid language
    if (!detectedLang || !["en", "fr", "ar"].includes(detectedLang)) {
      // Get browser language or use default
      const browserLang = navigator.language.split('-')[0];
      const preferredLang = ["en", "fr", "ar"].includes(browserLang) ? browserLang : "en";
      
      // Redirect to proper language URL
      window.location.href = `/${preferredLang}${location.pathname}`;
    } else if (detectedLang !== i18n.language) {
      i18n.changeLanguage(detectedLang);
    }
  }, [location.pathname, i18n]);

  return null;
}

export default function AppRoutes() {
  const location = useLocation();
  // const { lang } = useParams<{ lang: string }>();
  const { i18n } = useTranslation();

  useEffect(() => {
    TagManager.initialize(tagManagerArgs);
  }, []);

  useEffect(() => {
    const lang = getCurrentLocale();

    if (lang && ["en", "fr", "ar"].includes(lang)) {
      i18n.changeLanguage(lang);
    } else {
      i18n.changeLanguage("en"); // fallback
    }

    const windowObj = window as any;
    windowObj.dataLayer.push({
      event: "pageview",
      url: location.pathname,
    });
  }, [location]);


  // Detect browser language
  const detectLanguage = (): string => {
    const browserLang = navigator.language || "en";
    if (browserLang.startsWith("fr")) return "fr";
    if (browserLang.startsWith("ar")) return "ar";
    return "en";
  };

  const currentLang = getCurrentLocale();
  const isLangMissing = !["en", "fr", "ar"].includes(currentLang);

  // Redirect to detected language if it's missing
  if (isLangMissing && location.pathname === "/") {
    const browserLang = detectLanguage();
    return <Redirect to={`/${browserLang}`} />;
  }

  if (isLangMissing) {
    const browserLang = detectLanguage();
    return <Redirect to={`/${browserLang}${location.pathname}`} />;
  }
  return (
    <Switch>
      {/* Redirect root to /en by default */}
      <Route exact path="/">
        <Redirect to="/en" />
      </Route>

      {/* Language-aware routes */}
      <Route path="/:lang">
        <Switch>
          {authRoutes.map((item: any, index: any) => (
            <Route
              key={index}
              exact
              path={item.path}
              component={item.component}
            />
          ))}

          {routes.map((item, i) => (
            <Route key={i} exact path={`/:lang${item.newUrl}`}>
              <Redirect
                to={`/:lang/menu#${item.combo ? "combo" : "item"}/${
                  item.oldUrl
                }`}
              />
            </Route>
          ))}

          <Route path="*" component={Error404} />
        </Switch>
      </Route>
    </Switch>
  );
}
